import React from 'react'
import { ChargingSession } from '../../types/chargingSession.types'
import { ComponentInfoProps } from '../../../../common/types/componentInfo.types'
import { useSingleChargingSessionAdmin } from '../../hooks/useChargingSession'
import { limitString } from '../../../../utils/string.utils';
import { dateConverter } from '../../../../utils/dateConverter';
import { numberFormaterString } from '../../../../utils/numberFormater';


export default function SingleChargingSessionInfo({ info, id, emptyText, limitText, renderComponent }:ComponentInfoProps<ChargingSession>) {
  
    
    const { singleChargingSessionQuery: {isError, isLoading, data}} = useSingleChargingSessionAdmin(id);

    if (isLoading) return <>...</>
    if (isError) return <>{emptyText ? emptyText : ""}</>
    const translateInfo = (valueKey: keyof ChargingSession, valueRaw : any) => {
        if (!valueKey) return "";
        switch (valueKey) {

            case "cs_create_at":
                return dateConverter(valueRaw as any);
            case "cs_update_at":
                return dateConverter(valueRaw as any);
            case "cs_price":
                return numberFormaterString(valueRaw as any);
            case "cs_nb_kwh":
                return Number(valueRaw).toFixed(2);
            default:
                return valueRaw;
        }
    }

    
    if (renderComponent ){
        return<>{
         renderComponent({
        value: data?.[info],
        labelRender: <span>{info}</span>,
        goTo: () => null,
    })}
    </>
}

  
    const value = translateInfo(info,data?.[info])


    return (
    <> {value ? limitString(value, limitText): emptyText} </>
  )

}
